import { Link } from 'react-router-dom';
import { Facebook } from 'lucide-react';

const LOGO = "https://customer-assets.emergentagent.com/job_70c97ebb-d9b4-4dac-8385-96529bba2f67/artifacts/nvlni4cj_website%20photo%20twp.png";

const Footer = () => {
  return (
    <footer data-testid="footer" style={{ background: '#2B2B2B' }}>
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-20">
        <div className="grid md:grid-cols-3 gap-12 mb-12">

          <div>
            <div
              className="inline-block mb-5 rounded-xl p-2"
              style={{ background: 'rgba(247,244,239,0.1)' }}
            >
              <img
                src={LOGO}
                alt="Resonant Healing"
                className="h-12 w-auto object-contain"
              />
            </div>
            <p className="text-sm leading-relaxed mb-6" style={{ color: 'rgba(247,244,239,0.55)', fontFamily: 'Inter, sans-serif' }}>
              Trauma-informed healing through nervous system regulation, subconscious work, and energetic alignment.
            </p>
            <a
              href="https://www.facebook.com/profile.php?id=61565894824813"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-facebook-link"
              className="inline-flex items-center gap-2 transition-colors duration-200 hover:text-[#C6A96B]"
              style={{ color: 'rgba(247,244,239,0.5)', fontFamily: 'Inter, sans-serif', fontSize: '13px' }}
            >
              <Facebook size={16} strokeWidth={1.5} />
              <span>Follow on Facebook</span>
            </a>
          </div>

          <div>
            <p className="text-xs tracking-[0.25em] uppercase font-medium mb-6" style={{ color: '#A8B5A2' }}>
              Navigate
            </p>
            <div className="space-y-3">
              {[
                { to: '/', label: 'Home' },
                { to: '/services', label: 'Services' },
                { to: '/about', label: 'About' },
              ].map((link) => (
                <Link
                  key={link.to}
                  to={link.to}
                  className="block text-sm transition-colors duration-200 hover:text-[#C6A96B]"
                  style={{ color: 'rgba(247,244,239,0.6)', fontFamily: 'Inter, sans-serif' }}
                >
                  {link.label}
                </Link>
              ))}
              <a
                href="https://forms.gle/acnQmapg39FqW7wL7"
                target="_blank"
                rel="noopener noreferrer"
                className="block text-sm transition-colors duration-200 hover:text-[#C6A96B]"
                style={{ color: 'rgba(247,244,239,0.6)', fontFamily: 'Inter, sans-serif' }}
              >
                Apply
              </a>
            </div>
          </div>

          <div>
            <p className="text-xs tracking-[0.25em] uppercase font-medium mb-6" style={{ color: '#A8B5A2' }}>
              Begin
            </p>
            <p className="text-sm leading-relaxed mb-4" style={{ color: 'rgba(247,244,239,0.55)', fontFamily: 'Inter, sans-serif' }}>
              Ready to take the next step in your healing journey?
            </p>
            <a
              href="https://forms.gle/acnQmapg39FqW7wL7"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-apply-btn"
              className="inline-block rounded-full text-sm font-medium transition-all duration-300 hover:opacity-85 mb-8"
              style={{ background: '#C6A96B', color: '#2B2B2B', padding: '12px 28px' }}
            >
              Apply to Work Together
            </a>
            <div className="space-y-3">
              <a
                href="mailto:jennie@resonanthealing444.com"
                className="flex items-center gap-3 text-sm transition-colors duration-200 hover:text-[#C6A96B]"
                style={{ color: 'rgba(247,244,239,0.55)', fontFamily: 'Inter, sans-serif' }}
              >
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" style={{ width: '14px', height: '14px', flexShrink: 0 }}>
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" /><polyline points="22,6 12,13 2,6" />
                </svg>
                jennie@resonanthealing444.com
              </a>
              <a
                href="tel:8139567947"
                className="flex items-center gap-3 text-sm transition-colors duration-200 hover:text-[#C6A96B]"
                style={{ color: 'rgba(247,244,239,0.55)', fontFamily: 'Inter, sans-serif' }}
              >
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" style={{ width: '14px', height: '14px', flexShrink: 0 }}>
                  <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.81 19.79 19.79 0 01.12 1.18 2 2 0 012.11 0h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.09 7.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z" />
                </svg>
                813-956-7947
              </a>
            </div>
          </div>
        </div>

        <div
          className="pt-8 flex flex-col sm:flex-row justify-between items-center gap-4"
          style={{ borderTop: '1px solid rgba(168,181,162,0.15)' }}
        >
          <p className="text-xs" style={{ color: 'rgba(247,244,239,0.3)', fontFamily: 'Inter, sans-serif' }}>
            © {new Date().getFullYear()} Resonant Healing. All rights reserved.
          </p>
          <Link
            to="/admin"
            data-testid="footer-admin-link"
            className="text-xs transition-colors duration-200 hover:text-[#A8B5A2]"
            style={{ color: 'rgba(247,244,239,0.2)', fontFamily: 'Inter, sans-serif' }}
          >
            Admin
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
